var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.2353C2 10.553 2.58763 10 3.3125 10H14.6875C15.4124 10 16 10.553 16 11.2353V14.7647C16 15.447 15.4124 16 14.6875 16H3.3125C2.58763 16 2 15.447 2 14.7647V11.2353ZM3.3125 11.0588C3.20894 11.0588 3.125 11.1378 3.125 11.2353V14.7647C3.125 14.8622 3.20894 14.9412 3.3125 14.9412H14.6875C14.7911 14.9412 14.875 14.8622 14.875 14.7647V11.2353C14.875 11.1378 14.7911 11.0588 14.6875 11.0588H3.3125Z",
    fill: "#929298"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.23529C2 2.55304 2.58763 2 3.3125 2H14.6875C15.4124 2 16 2.55305 16 3.23529V6.76471C16 7.44695 15.4124 8 14.6875 8H3.3125C2.58763 8 2 7.44696 2 6.76471V3.23529ZM3.3125 3.05882C3.20894 3.05882 3.125 3.13783 3.125 3.23529V6.76471C3.125 6.86217 3.20894 6.94118 3.3125 6.94118H14.6875C14.7911 6.94118 14.875 6.86218 14.875 6.76471V3.23529C14.875 3.13782 14.7911 3.05882 14.6875 3.05882H3.3125Z",
    fill: "#929298"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow);
export default __webpack_public_path__ + "static/media/row.b57177068afb4538df6aaa7ad37205a0.svg";
export { ForwardRef as ReactComponent };